import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

/**
 * D-541 AD-3 (рішення C): topbar-пошук = пошук клієнтів. Клік або ⌘K/Ctrl+K →
 * /clients з фокусом у search-input (?focus=search, ClientsListPage знімає
 * параметр після фокусування). 0 backend; command-palette (F0B) — майбутнє,
 * мертвого onClick більше нема (§0).
 */
export function CommandPaletteStub() {
  const navigate = useNavigate();
  const goSearch = () => navigate("/clients?focus=search");

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        navigate("/clients?focus=search");
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  return (
    <button
      type="button"
      onClick={goSearch}
      className="hidden md:inline-flex items-center gap-2 h-10 w-72 rounded-md border border-input bg-background px-3 text-sm text-muted-foreground hover:bg-accent transition-colors"
    >
      <Search className="w-4 h-4" />
      <span>Пошук клієнтів…</span>
      <kbd className="ml-auto inline-flex items-center gap-1 rounded border bg-muted px-1.5 py-0.5 text-[12px] font-medium text-muted-foreground">
        ⌘K
      </kbd>
    </button>
  );
}
